<template>
  <div class="pa-4 text-center">

    <v-dialog v-model="dialog" transition="dialog-bottom-transition" max-width="800" persistent>
      <v-card class="container justify-content-between align-items-center">
        <img src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" />
        <h2>{{ $t('login.termsConditions.label.title') }}</h2>
        <v-container>
          <p>{{ terms_Conditions.message }}</p>
          <ul v-for="terms in terms_Conditions.listTermsUrl" :key="terms.termsAndConditionsId"> 
            <li>
              {{ terms.description }} 
              <a :href="terms.urlTermsAndConditions" target="_blank" rel="noopener">
                <v-icon color="primary">mdi-launch</v-icon>
              </a>
            </li>
          </ul>
          <div class="options">
            <v-btn large block rounded color="primary" @click="rejectTyC()">
              {{ $t('button.reject') }}
            </v-btn>
            <v-btn large block rounded color="primary" @click="aceptTyC()">
              {{ $t('button.accept') }}
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  LOGIN_M,
  GET_TERMS_CONDITIONS,
  ACTION_GET_TERMS_CONDITIONS,
  ACTION_POST_TERMS_CONDITIONS
} from "@/views/login/store/types/types.js";
import { mapActions, mapGetters } from 'vuex';

export default {
  name: "termsConditionsComponents",
  props: {
    termsConditions: {
      required: true,
      type: Boolean
    },
  },
  data() {
    return {
      dialog: true,
      terms_Conditions: {}
    }
  },
  async mounted(){
    if (!this.termsConditions) {
      await this.actionGetTyC()
      this.terms_Conditions = await this.getInfoTyC()
    }
  },

  methods: {
    ...mapActions({
      actionGetTyC: `${LOGIN_M}${ACTION_GET_TERMS_CONDITIONS}`,
      aceptTyC: `${LOGIN_M}${ACTION_POST_TERMS_CONDITIONS}`,
    }),

    ...mapGetters({
      getInfoTyC: `${LOGIN_M}${GET_TERMS_CONDITIONS}`,
    }),

    rejectTyC(){
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      sessionStorage.removeItem('idGroup');
      sessionStorage.removeItem('idUsuario');
      sessionStorage.removeItem('idEmpresa');
      this.dialog = this.termsConditions;
      window.location.reload();
    }

  }
}
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

img {
  width: 30vh;
}

.container {
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  font-size: 2.8vh;
}

h2{
  color: #6E17A5;
}

p{
  padding: 15px;
  margin: 0;
}

ul, li{
  display: flex;
  gap: 10px;
  color: gray;
}

.options{
  display: flex;
  width: 150px;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}

@media screen and (max-width: 900px) {
  img {
    width: 20vh;
  }

  h2{
    font-size: 30px;
  }

  p, ul, li{
    font-size: 18px;
  }

}
</style>